
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whitepapers/[id]",
      function () {
        return require("private-next-pages/whitepapers/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whitepapers/[id]"])
      });
    }
  